<div (click)="onClick($event)" class="checkbox-container" [ngClass]="{ disabled }" [matTooltip]="tooltip">
  <input (change)="onChange($event)" (click)="onClick($event)" type="checkbox" #checkbox [checked]="checked" [disabled]="disabled"/>
  <span *ngIf="title" class="title">{{title}}</span>
</div>
